import React from 'react'

function index(props) {
  return <div>준비중입니다.</div>
}

export default index
